import React from "react";
import { IconProps } from "./IconProps";

const PrinterIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "20Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.1989 5.86179H15.1482V3.57036C15.1482 3.26016 14.8981 3 14.5779 3H5.42214C5.11194 3 4.85178 3.25016 4.85178 3.57036V5.86179H3.80113C2.8005 5.86179 2 6.63227 2 7.57286V13.2864C2 13.5966 2.25016 13.8568 2.57036 13.8568H4.86179V16.1482C4.86179 16.4584 5.11194 16.7186 5.43215 16.7186H14.5779C14.8881 16.7186 15.1482 16.4684 15.1482 16.1482V13.8568H17.4396C17.7498 13.8568 18.01 13.6066 18.01 13.2864V7.57286C18.01 6.63227 17.1995 5.86179 16.1989 5.86179ZM5.9925 4.13071H14.0075V5.85178H5.9925V4.13071ZM14.0075 15.5779H5.9925V12.1357H14.0075V15.5779ZM16.8693 12.7161H15.1482V11.5654C15.1482 11.2552 14.8981 10.995 14.5779 10.995H5.42214C5.11194 10.995 4.85178 11.2452 4.85178 11.5654V12.7161H3.13071V7.56285C3.13071 7.24265 3.43089 6.98249 3.80113 6.98249H16.1889C16.5591 6.98249 16.8593 7.24265 16.8593 7.56285V12.7161H16.8693Z"
            fill={color}
          />
          <path
            d="M14.2872 8.28333C13.8972 8.28333 13.5772 8.60332 13.5772 8.99332C13.5772 9.38332 13.8972 9.70332 14.2872 9.70332C14.6772 9.70332 14.9972 9.38332 14.9972 8.99332C14.9972 8.60332 14.6772 8.28333 14.2872 8.28333Z"
            fill={color}
          />
        </svg>
      );
    case "20Thin":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 2.625C4.72386 2.625 4.5 2.84886 4.5 3.125V5.75H3.22891C2.24354 5.75 1.375 6.4963 1.375 7.5V13.75C1.375 14.0261 1.59886 14.25 1.875 14.25H4.5V16.875C4.5 17.1511 4.72386 17.375 5 17.375H15C15.2761 17.375 15.5 17.1511 15.5 16.875V14.25H18.125C18.4011 14.25 18.625 14.0261 18.625 13.75V7.5C18.625 6.4963 17.7565 5.75 16.7711 5.75H15.5V3.125C15.5 2.84886 15.2761 2.625 15 2.625H5ZM3.22891 6.75H5H15H16.7711C17.281 6.75 17.625 7.12245 17.625 7.5V13.25H15.5V11.875C15.5 11.5989 15.2761 11.375 15 11.375H5C4.72386 11.375 4.5 11.5989 4.5 11.875V13.25H2.375V7.5C2.375 7.12245 2.71896 6.75 3.22891 6.75ZM5.5 5.75H14.5V3.625H5.5V5.75ZM14.5 12.375V13.75V16.375H5.5V13.75V12.375H14.5ZM15.3125 9.0625C15.3125 9.40768 15.0327 9.6875 14.6875 9.6875C14.3423 9.6875 14.0625 9.40768 14.0625 9.0625C14.0625 8.71732 14.3423 8.4375 14.6875 8.4375C15.0327 8.4375 15.3125 8.71732 15.3125 9.0625Z"
            fill={color}
          />
        </svg>
      );
    case "32Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 4.25C7.58579 4.25 7.25 4.58579 7.25 5V9.25H5.16625C3.61344 9.25 2.25 10.4254 2.25 12V22C2.25 22.4142 2.58579 22.75 3 22.75H7.25V27C7.25 27.4142 7.58579 27.75 8 27.75H24C24.4142 27.75 24.75 27.4142 24.75 27V22.75H29C29.4142 22.75 29.75 22.4142 29.75 22V12C29.75 10.4254 28.3866 9.25 26.8337 9.25H24.75V5C24.75 4.58579 24.4142 4.25 24 4.25H8ZM5.16625 10.75H8H24H26.8337C27.6734 10.75 28.25 11.3646 28.25 12V21.25H24.75V19C24.75 18.5858 24.4142 18.25 24 18.25H8C7.58579 18.25 7.25 18.5858 7.25 19V21.25H3.75V12C3.75 11.3646 4.32656 10.75 5.16625 10.75ZM8.75 9.25H23.25V5.75H8.75V9.25ZM23.25 19.75V22V26.25H8.75V22V19.75H23.25ZM24.75 14.5C24.75 15.1904 24.1904 15.75 23.5 15.75C22.8096 15.75 22.25 15.1904 22.25 14.5C22.25 13.8096 22.8096 13.25 23.5 13.25C24.1904 13.25 24.75 13.8096 24.75 14.5Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default PrinterIcon;
